import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const AccordianMinusIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 10L9.8781 10L1.75619 10"
      stroke="#EEF7FF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.75781 10L9.87972 10H18.0016"
      stroke="#EEF7FF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default AccordianMinusIconDark;
